import { render, staticRenderFns } from "./ChildrenIndex.vue?vue&type=template&id=fa8ab7fc"
import script from "./ChildrenIndex.vue?vue&type=script&lang=ts"
export * from "./ChildrenIndex.vue?vue&type=script&lang=ts"
import style0 from "./ChildrenIndex.vue?vue&type=style&index=0&id=fa8ab7fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports